import styled from 'styled-components';

const MyDiv = styled.div`
  .table_wrapper {
    background: #fff;
    border-radius: 7px;
    border:1px;
    box-shadow: 0 1px 4px rgba(234, 236, 240, 1);
    border-width: 1px; 
  }
  th, td {
    text-align: left;
    padding: 12px;
    font-size: 14px;
  }
  th {
    font-weight: 600;
    color: #1a202c;
  }
   .empId {
    text-decoration: underline;
    color: rgba(0, 122, 255, 1);
    display: inline-flex;
    align-items: center;
    padding: 4px 8px; 
    border-radius: 16px;
    cursor: pointer;
    white-space: nowrap; 
    cursor: pointer;
  }

`;


export default MyDiv;